import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { user } from 'services';
import { path } from 'router/sections';
import { TableExt, TableInfo, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import { getTableParams } from './grid.params';

export const BenefitGrid = (props) => {
  const { count, count_limit, count_method, getFilter, entries, className, theme, getXlsAction } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const rightView = user.haveRight('stays.view');

  /**
   * open new tab with stay card
   * @param {*} row
   * @returns
   */
  const onRowDblClick = (row) => {
    if (!row.stay_id || !rightView) {
      return;
    }
    window.open(path('stay') + '?id=' + row.stay_id, '_blank', 'noopener,noreferrer');
  };

  /**
   * showinfo
   * @param {*} row
   */
  const showInfo = (row) => {
    if (!row.stay_id || !rightView) {
      return;
    }
    history.push(`${path('stay')}?id=${row.stay_id}`);
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const actions = [];

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }

  const tableParams = useMemo(() => getTableParams(t), []);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('benefit', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} count_limit={count_limit} count_method={count_method} getFilter={getFilter} actions={topActions} />

      <TableExt
        theme={theme}
        title={t('sections.Льготы')}
        rows={{ count, items }}
        actions={actions}
        className={className}
        refresh={props.refresh}
        onRowClick={showInfo}
        onRowDblClick={rightView ? onRowDblClick : undefined}
        {...restTableParams}
        fields={fields}
      />
    </GridBox>
  );
};
